import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6.975 2.4a.7.7 0 0 0-.7.7v.5h-2.6a.7.7 0 0 0-.7.7v12.6a.7.7 0 0 0 .7.7h12.6a.7.7 0 0 0 .7-.7v-2.1a.7.7 0 1 0-1.4 0v1.4h-11.2V5h1.9v.6a.7.7 0 0 0 .7.7h6a.7.7 0 0 0 .7-.7V5h1.9v.9a.7.7 0 1 0 1.4 0V4.3a.7.7 0 0 0-.7-.7h-2.6v-.5a.7.7 0 0 0-.7-.7h-6Zm.7 2.5V3.8h4.6v1.1h-4.6Zm-.7 3.3a.7.7 0 1 0 0 1.4h4.321a.7.7 0 1 0 0-1.4H6.975Zm0 2.357a.7.7 0 1 0 0 1.4h1.964a.7.7 0 1 0 0-1.4H6.975Zm0 2.357a.7.7 0 1 0 0 1.4h1.571a.7.7 0 1 0 0-1.4H6.975Zm9.468-5.216a.7.7 0 0 1 .983.12l1.45 1.858a.7.7 0 0 1-.12.982l-5.013 3.917a.7.7 0 0 1-.434.148l-1.903-.008a.7.7 0 0 1-.678-.866l.453-1.85a.7.7 0 0 1 .25-.385l5.012-3.916Zm.31 1.534-4.27 3.336-.184.75.773.004 4.27-3.336-.589-.754Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
